import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fetchAuthSession, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { CommonDataService } from '@shared/services/common-data.service';
import { confirm, custom, alert } from 'devextreme/ui/dialog';
import { PreviewPdfService } from '@shared/services/preview-pdf.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  standalone: false
})
export class LoginComponent implements OnInit {
  uuid: any;
  checkForLog: boolean = true;
  fileName = "";
  hideLoader: boolean = true;
  firstLogin: boolean = false;
  resMessage: any;
  constructor(
    private router: Router,
    private zone: NgZone,
    private commonServices: CommonDataService,
    private _preview: PreviewPdfService
  ) {
    this.hubInterface();
  }

  ngOnInit(): void {
    this.checkFirstLogin();
    this.uuid = this.fetchUUIDFromUrl();
    console.log(this.uuid, 'UUID on login component init');
    fetchAuthSession()
      .then(() => {
        if (this.firstLogin || !this.checkForLog) {
          this.commonServices.createAuthorizationToken().subscribe(r => {
            if (r.status == "SUCCESS") {
              window.localStorage.setItem('cookieDetails', r.status);
              window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
              window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime);
              this.urlDownloadPDF();
            }
          })
        } else {
          const chkTimeCookie = window.localStorage.getItem('cookieDetails');
          if (chkTimeCookie) {
            this.urlDownloadPDF();
          } else {
            window.localStorage.removeItem("mp-serve-auth");
            window.localStorage.removeItem("mpuserdetailslock");
            window.localStorage.removeItem("mpUInfo");
            window.localStorage.removeItem('cookieDetails');
            window.localStorage.removeItem('cookieStartTimer');
            window.localStorage.removeItem('cookieEndTimer');
            this.validateAndRedirect();
          }
        }
      }).catch((err) => {
        this.validateAndRedirect();
      })
  }

  async checkFirstLogin() {
  
      // Fetch current auth session
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;
  
      if (!idToken) {
        // User not logged in
        return false;
      }
  
      const claims = idToken.payload;
      const userId = claims.sub; // unique identifier for the user
  
      // Compose a localStorage key for this user
      const key = `firstLogin_${userId}`;
      console.log(window.localStorage);
      if (!window.localStorage.getItem(key)) {
        //First login detected on this browser
        window.localStorage.setItem(key, "true");
        this.firstLogin = true;
        return true;
      }
      this.firstLogin = false;
  
      // Already logged in before
      return false;
  }
  


  hubInterface() {
    Hub.listen('core', (data: any) => {
      switch (data.payload.event) {
        case 'customOAuthState':
          let gedState = data.payload.data;
          if (gedState == "mpg") {
            this.firstLogin = !this.firstLogin;
          } else {
            this.uuid = data.payload.data;
            this.checkForLog = !this.checkForLog;
            this.downloadPDF(this.uuid);
          }
          break;
      }
    });
  }

  downloadPDF(getUUID: any) {
    this.commonServices.createAuthorizationToken().subscribe(r => {
      if (r.status == "SUCCESS") {
        window.localStorage.setItem('cookieDetails', r.status);
        window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
        window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime);

        let id = this._preview.payloadList.length;
        this._preview.payloadList.push({
          payload: { "uuid": getUUID },
          url: environment.reportUrl + "/accessWeeklyPSR",
          fileName: '',
          checkResponseForFileName: true
        });
        window.localStorage.setItem("pdfPayload", JSON.stringify(this._preview.payloadList));
        window.open("preview-pdf/" + id.toString(), '_self');
      }
    });

  }

  login() {
    if (this.checkForLog) {
      this.commonServices.getUser().subscribe(r => {
        if (r.status == "SUCCESS" && r.serviceResult.activeFlag && (r.serviceResult.userRole != null)) {
          this.commonServices.fetchAllCommonData();
          this.commonServices.checkAuth.next(r.serviceResult.activeFlag);
          this.commonServices.userData.next(r.serviceResult.userRole.sectionPermissions);
          this.commonServices.userInfo.next(r.serviceResult);
          window.localStorage.setItem("mp-serve-auth", JSON.stringify(r.serviceResult.activeFlag));
          window.localStorage.setItem("mpuserdetailslock", JSON.stringify(r.serviceResult.userRole.sectionPermissions));
          window.localStorage.setItem("mpUInfo", JSON.stringify(r.serviceResult));
          
            if (this.uuid !== null && this.uuid !== undefined) {
              this.downloadPDF(this.uuid);
            }
            else {
              console.log("No UUID found, redirecting to home.");
              this.zone.run(() => this.router.navigate(['/home']));
            }

        } else if (r.serviceResult.userRole == null) {
          //if user role is null and uuid download pdf else call api to get uuid
          if (this.uuid !== null && this.uuid !== undefined) {
            this.downloadPDF(this.uuid);
          }
          else {
            this.commonServices.getDisUser().subscribe({
              next: (r) => {
                if (r.status == "SUCCESS" && r.serviceResult) {
                  this.resMessage = "Please wait, You will be re-directed to the Report page."
                  this.downloadPDF(r.serviceResult);
                } else {
                  this.router.navigate(['auth/unauthorized']);
                }
              },
              //in case of 500 error it will redirect to unauthorized page
              error: (err) => {
                this.router.navigate(['auth/unauthorized']);
              }
            });
          }
        }
        else {
          console.log("LOGIN ELSE GET called");
        }
      });
    }
  }
  fetchUUIDFromUrl() {
    const url = this.firstLogin ? window.localStorage.getItem('postLoginRedirect') : window.location.href;
    if (url && url.includes('download')) {
      const parts = url.split('/');
      const lastPart = parts[parts.length - 1];
      const allLastParts = lastPart.split('=')
      const uuid = allLastParts[allLastParts.length - 1];
      return uuid;
    }
    return null;
  }

  urlDownloadPDF() {
    //const url = new URL(window.location.href);
    const url = this.firstLogin ? window.localStorage.getItem('postLoginRedirect') : window.location.href;

    console.log(url, 'urlDownloadPDF');
    if (url && url.includes('download')) {
      const parts = url.split('/');
      const lastPart = parts[parts.length - 1];
      const allLastParts = lastPart.split('=')
      const uuid = allLastParts[allLastParts.length - 1];
      console.log(uuid, 'urlDownloadPDF');
      if (uuid) {
        this.downloadPDF(uuid);
      }
    } else {
      this.login();
    }
  }

  validateAndRedirect() {

   // const url = new URL(window.location.href);
    const url = this.firstLogin ? window.localStorage.getItem('postLoginRedirect') : window.location.href;
    if (url && url.includes('download')) {
      const parts = url.split('/');
      console.log(parts, 'validateAndRedirect');
      const lastPart = parts[parts.length - 1];
      const allLastParts = lastPart.split('=')
      const uuid = allLastParts[allLastParts.length - 1];
      //const uuid = uuidParam ? uuidParam : parts[parts.length - 2];
      const config = {
        provider: {
          custom: environment.federatedProvider,
        },
        customState: uuid,
      };
      this.fedaratedUI(config);
    }
    else {
      const config = {
        provider: {
          custom: environment.federatedProvider,
        },
        customState: "mpg",
      };
      this.fedaratedUI(config);
    }
  }

  fedaratedUI(config: any) {
    fetchAuthSession()
      .then(() => {
        const chkTimeCookie = window.localStorage.getItem('cookieDetails');
        if (chkTimeCookie) {
          this.login();
        } else {
          this.commonServices.createAuthorizationToken().subscribe(r => {
            if (r.status == "SUCCESS") {
              window.localStorage.setItem('cookieDetails', r.status);
              window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
              window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime);
              this.login();
            } else {
              this.router.navigate(['auth/unauthorized']);
            }
          })
        }

      }).catch((err) => {

        signInWithRedirect(config);
      })
  }
}
